// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";
import { Category, GetCategoriesApiParameter } from "@insite/client-framework/Services/CategoryService";
import { CategoryCollectionModel, CategoryModel } from "@insite/client-framework/Types/ApiModels";
import { HubSpotAdditionalInfoFormFields } from "@west/App/Widgets/HubSpot/HubSpotAdditionalInfoForm";

const hubspotUrl = "api/fam/hubspot/save";

export interface HubSpotInfoParameters
    extends ApiParameter,
        Omit<HubSpotAdditionalInfoFormFields, "frequentlyPurchasedProducts"> {
    frequentlyPurchasedProducts: string;
}

export async function saveHubSpotAdditionalInfo(parameter: HubSpotInfoParameters) {
    try {
        const hubSpotSaveResult = await post<any>(`${hubspotUrl}`, parameter);
        return {
            result: hubSpotSaveResult,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: (error as any)?.errorJson?.message,
        };
    }
}
